// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_b1Q","cls2":"LoswpTabsHero-cls2_heO LoswpTabsHero-cls1_b1Q"};